"use client";
import { ProductData } from '@/app/center/footprint/page';
import React from 'react';

function Index() {
  // console.log(footprintData,'我的历史数据，需要进行循环');
  
  return (
    <div className="">
      <div className="flex justify-between items-center mb-6 ">
        <div className="flex  items-start">
          <h2 className="text-lg font-bold border-b-[3px] border-main pr-4 pb-1">我的足迹</h2>
          <p className="text-gray-500 text-sm  self-end">（我浏览过的商品）</p>
        </div>

        <button className="bg-main px-4 py-1 text-white  text-sm">
        <i className="ri-delete-bin-line"></i> 清空全部足迹
        </button>
      </div>

      <div className="space-y-4">
        <div className="border-b mb-8">
          <div className='flex items-center mb-4'>
          <h3 className="font-bold pr-4">12月27日</h3>
          <div className='flex-1 border-t border-dashed border-[#000]'></div>
          </div>


          <div>
          <div className="flex items-center justify-between  border-[1px] border-[#e6e6e6] p-4 mb-4 ">
            <div className="flex items-center ">
              <img
                alt="夹持装置自锁同步申标S3M/S5M/S8M型"
                className="w-20 h-20 object-cover mr-4"
                height="80"
                src="https://dinjian-api.pinshop.com/attachment/images/2024/07/27/image_1722070290_oPF754UW.jpg"
                width="80"
              />
              <div className='h-full  flex flex-col  justify-between'>
                <h4 className="font-bold mb-5">
                  夹持装置自锁同步申标S3M/S5M/S8M型
                </h4>
                <p className="text-gray-500 text-sm">商城价：¥0.00</p>
              </div>
            </div>
            <div className="">
            <p>
              <button className="border border-mian text-mian w-[100px] h-[30px] rounded-sm   text-sm mb-4">
                查看详情
              </button>
              </p>

              <p>
              <button className="bg-main text-white w-[100px] h-[30px] rounded-sm text-sm">
                删除该记录
              </button>
              </p>
            </div>
          </div>

          <div className="flex items-center justify-between  border-[1px] border-[#e6e6e6] p-4 mb-4 ">
            <div className="flex items-center ">
              <img
                alt="夹持装置自锁同步申标S3M/S5M/S8M型"
                className="w-20 h-20 object-cover mr-4"
                height="80"
                src="https://dinjian-api.pinshop.com/attachment/images/2024/07/27/image_1722070290_oPF754UW.jpg"
                width="80"
              />
              <div className='h-full  flex flex-col  justify-between'>
                <h4 className="font-bold mb-5">
                  夹持装置自锁同步申标S3M/S5M/S8M型
                </h4>
                <p className="text-gray-500 text-sm">商城价：¥0.00</p>
              </div>
            </div>
            <div className="">
            <p>
              <button className="border border-mian text-mian w-[100px] h-[30px] rounded-sm   text-sm mb-4">
                查看详情
              </button>
              </p>

              <p>
              <button className="bg-main text-white w-[100px] h-[30px] rounded-sm text-sm">
                删除该记录
              </button>
              </p>
            </div>
          </div>
          </div>

        </div>


      </div>
    </div>
  );
}

export default React.memo(Index);
